export default __webpack_public_path__ + "static/media/Swiss-Spring-Flower.efc66910.jpg";